import data from './components/index.js';
import { getSettleDetailLists, cancelApply, cancelApplyE, getInvoiceInfo } from '../../../api/settleDetails';
import { getAfreshCheck } from '../../../api/billDetails';
import { upload, salesUpload } from '../../../api/invoice';
import { extsysInvoiceQuery } from '@/modules/transport/bms/api/invoiceManageApi.js';
const STATUS = {
    new_build: 10, // 新建
    calculate_apply: 44, // 计算申请中
    bms_audit_back: 47, // BMS审核驳回
    already_share_audit: 50, // 已提交共享审核
    share_audit_fail: 51, // 提交共享审核失败
    share_audit_succeed: 60, // 共享审核通过
    share_audit_back: 70, // 共享审核驳回
    cancellation: 80 // 作废
};
// eslint-disable-next-line no-unused-vars
const INVOICE_STATUS = {
    not_uploading: 10, // 未上传
    portion_uploading: 20, // 部分上传
    all_uploading: 30, // 全部上传
    wait_receive: 40, // 待接收
    portion_receive: 50, // 部分接收
    all_receive: 60, // 全部接受
    invoice_back: 70 // 发票驳回
};

export default {
    data() {
        return {
            isInvoLoad: false,
            sendVisible: false,
            dialogVisible: false,
            isLoading: false,
            isEleLoading: false,
            isSendBack: true,
            isMail: true,
            isUpload: true,
            isShow: true,
            isRecall: true,
            loading: true,
            ifConfirm: false,
            isSeal: false,
            diaShaow: false,
            isSendBackLoading: false,
            isInvoiceNo: true,
            isDisabled: true,
            isGenerationKnot: false,
            isNetworkInfos: false,
            rowData: {},
            process: {
                step: []
            },
            dataRow: {},
            infoData: {},
            dataObj: {
                totalAmount: '',
                totalAmt: '',
                fineAmt: ''
            },
            payObj: {
                deliveryCompany: ''
            },
            taxRateData: [],
            tableDataLists: [],
            tableDataItems: [],
            invoiceItems: [],
            invoiceLists: [],
            networkInfoLists: [],
            networkInfoItems: [],
            data,
            title: '',
            deliveryNo: '',
            titlePicture: '',
            imgUrl: '',
            status: '',
            INVOstatus: '',
            ledgerId: '',
            recVer: '',
            addNum: '',
            allAmt: 0,
            preAmt: 0,
            replaceSettlement: '',
            taxDifference: 0,
            classification: 0,
            invoiceStatus: 0,
            activeName: 'first',
            dicData: [],
            totalAmountNumber: '',
            uploadDataArr: [],
            uploadNumbers: 0
        };
    },
    methods: {
        formatData(data) {
            data.map(item => {
                item.type = item.type !== '01' ? '服务商' : '工程师';
                switch (item.payStatus) {
                case 0:
                    item.payStatus = '未支付';
                    break;
                case 1:
                    item.payStatus = '支付失败';
                    break;
                case 2:
                    item.payStatus = '已到服务商专用户';
                    break;
                case 3:
                    item.payStatus = '已到工程师账户';
                    break;
                case 4:
                    item.payStatus = '已到服务商现汇户';
                    break;
                case 5:
                    item.payStatus = '支付中';
                    break;
                }
            });
            return data;
        },
        showHendle() {
            this.isSave = true;
            this.isUpdate = true;
            this.isSend = true;
            this.isSubmit = true;
            this.isRecall = true;
            this.isCancell = true;
            this.isDellInvoice = true;
            this.isInvose = true;
            this.annexesFlag = true;
            // 新建且为未上传  部分上传 全部上传
            if (this.currObject.status === STATUS.new_build && this.currObject.invoiceStatus < INVOICE_STATUS.wait_receive) { // 保存 上传发票 作废
                this.isSave = false;
                this.isUpdate = false;
                // 全部上传 新建
                if (this.currObject.invoiceStatus === INVOICE_STATUS.all_uploading && this.currObject.status === STATUS.new_build) {
                    this.isSend = false;
                }
                // 发票驳回
                if (this.currObject.invoiceStatus === INVOICE_STATUS.wait_receive) {
                    this.isUpdate = false;
                    this.isSave = false;
                }
            }
            // 审核驳回 发票驳回
            if (this.currObject.status === STATUS.bms_audit_back && this.currObject.invoiceStatus === INVOICE_STATUS.invoice_back) { // 保存 上传发票 作废 发票删除
                this.isSave = false;
                this.isUpdate = false;
                this.isSend = false;
                this.isSubmit = false;
            }
            if (this.currObject.status === STATUS.bms_audit_back || this.currObject.status === STATUS.new_build) {
                this.isCancell = false;
            }
            // 审核驳回 全部上传
            if (this.currObject.status === STATUS.bms_audit_back && this.currObject.invoiceStatus === INVOICE_STATUS.all_uploading) { // 发票寄出 // 预留
                this.isSend = false;
                this.isSave = false;
                this.isUpdate = false;
            }
            if (this.currObject.status === STATUS.new_build && this.currObject.invoiceStatus === INVOICE_STATUS.wait_receive) { // 提交付款
                this.isSubmit = false;
                this.isSave = false;
            }
            if (this.currObject.status === STATUS.bms_audit_back && this.currObject.invoiceStatus === INVOICE_STATUS.wait_receive) { // 提交付款  ？
                this.isSubmit = false;
                this.isSave = false;
            }
            if (this.currObject.status === STATUS.calculate_apply && this.currObject.invoiceStatus === INVOICE_STATUS.wait_receive) { // 撤回提交
                this.isRecall = false;
            }
            if (this.currObject.invoiceStatus <= INVOICE_STATUS.portion_uploading && this.currObject.status !== STATUS.cancellation) { // 上传照片
                this.isUpdate = false;
                this.isSave = false;
            }
            if (this.currObject.invoiceStatus === INVOICE_STATUS.portion_uploading && this.currObject.status === STATUS.new_build) {
                this.isInvose = false;
            }
            if (this.currObject.invoiceStatus === INVOICE_STATUS.all_uploading && this.currObject.status === STATUS.new_build) {
                this.isInvose = false;
            }
            if (this.currObject.invoiceStatus === INVOICE_STATUS.not_uploading) {
                this.isInvose = false;
            }
            if (this.currObject.status === STATUS.bms_audit_back) {
                this.isInvose = false;
            }
            if (this.currObject.status === STATUS.new_build || this.currObject.status === STATUS.bms_audit_back ||
                this.currObject.status === STATUS.share_audit_fail || this.currObject.status === STATUS.share_audit_back) {
                this.annexesFlag = false;
            }
        },
        updateCourier(data) {
            data.jobId = this.currObject.jobId;
            data.apApplyNo = this.currObject.apApplyNo;
            if (this.currObject.status === STATUS.bms_audit_back) {
                this.$confirm('请复核驳回原因是否都处理完毕?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.getInvoiceOperation(data);
                    this.getApApply();
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            } else {
                this.getInvoiceOperation(data);
            }
        },
        load() {
            if (this.$route.query.hasOwnProperty('apApplyNo')) {
                this.loading = true;
                const params = { apApplyNo: this.$route.query.apApplyNo, jobId: this.$route.query.jobId };
                getSettleDetailLists(params).then(async res => {
                    if (res && res.code === '0') {
                        this.currObject = res.data.list[0] || {};
                        const { invoiceStatus, status, payStatus } = this.currObject;
                        this.invoiceStatus = invoiceStatus || '';
                        this.status = status || '';
                        this.payStatus = payStatus || '';
                        this.isSmartInvoice = this.currObject && !!Number(this.currObject.eisInvoicing);
                        this.manualFlag = this.currObject && !!Number(this.currObject.manualFlag);
                        this.cancelAmt = parseFloat(this.currObject.fineAfterAmt + this.currObject.chargeoffPreAmt + this.currObject.depositAmt +
                            this.currObject.chargeoffArAmt + this.currObject.preInvoiceAmt + (this.currObject.oilAmount !== null ? this.currObject.oilAmount : 0)).toFixed(2);
                        this.recVer = data.recVer;
                        this.ledgerId = data.ledgerId;
                        if (!this.currObject.remark) {
                            this.remarkOK = true;
                        }
                        this.checkSystemParamIncludeFiliale(this.currObject.companyCode);
                        this.showHendle();
                        this.transformation(this.currObject);
                        this.apApplyListApDetail();
                        this.apApplyListApDetail();
                        await this.getInvoiceList();
                        this.getSuContract();
                        this.getNetworkInfos();
                        this.accessory();
                        this.visualization();
                        this.loadDetails();
                    }
                }).finally(() => {
                    this.loading = false;
                });
            } else {
                this.loading = false;
                return false;
            }
        },
        handleDialog(formName) {
            if (formName.state) {
                const formLists = formName.data;
                const formData = new FormData();
                formData.append('taxNo', formLists.taxNo);
                formData.append('invoiceNo', formLists.invoiceNo);
                formData.append('invoiceCode', formLists.invoiceNumber);
                formData.append('invoiceDate', formLists.billingDate);
                formData.append('invoiceAmount', formLists.invoiceAmount);
                formData.append('invoiceType', formLists.invoiceType);
                formData.append('businessId', this.$route.query.jobid);
                formData.append('systemSource', '10');
                this.$refs.dialogVisible.isDialogLoading = true;
                getAfreshCheck(formData).then(res => {
                    if (res && res.code === '0') {
                        this.$message.success('重新查验成功');
                        this.$refs.dialogVisible.isDialogLoading = false;
                        this.$refs.dialogVisible.isReexamination = true;
                        this.$refs.dialogVisible.isDell = false;
                    } else {
                        this.$refs.dialogVisible.isDialogLoading = false;
                        this.$refs.dialogVisible.isReexamination = false;
                        this.$refs.dialogVisible.isDell = true;
                    }
                    this.getInvoiceList();
                }).catch(() => { });
            } else {
                return false;
            }
        },
        // 作废
        async cancellClick() {
            if (this.isSmartInvoice) {
                // 发票表的智汇票开票标识为是
                const res = await getInvoiceInfo({ apApplyNo: this.currObject.apApplyNo });
                if (res && res.code === '0' && res.data && res.data.list && res.data.list.length) {
                    // 该结算申请单号在【发票登记BMS.EF_INVOICE_HEADER】存在发票信息
                    this.$confirm('该结算申请单已存在发票，是否红冲？', '提示', {
                        confirmButtonText: '是',
                        cancelButtonText: '否',
                        type: 'warning'
                    }).then(() => {
                        this.openAssoSmartInvoiceDialog = true;
                    }).catch(() => {
                        this.$confirm(`系统会自动移除发票，重新生成结算申请单可以再次关联这些发票，请确定是否继续作废结算申请单？`, '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning',
                            beforeClose: (action, instance, done) => {
                                if (action === 'confirm') {
                                    this.loading = true;
                                    const params = { jobId: this.currObject.jobId, 'isRedFlush': 'N' };
                                    cancelApplyE(params).then(res => {
                                        if ((res && res.code === '0' && res.data ? res.data.code === '0' : true)) {
                                            this.$message.success('作废成功');
                                            this.apApplyListApDetail();
                                            this.apApplyListApDetail();
                                            this.getApApply();
                                            this.getInvoiceList();
                                        } else {
                                            this.$message.error(res.data.msg);
                                        }
                                        this.loading = false;
                                    }).finally(() => {
                                        done();
                                        instance.confirmButtonText = '确定';
                                        instance.confirmButtonLoading = false;
                                        instance.cancelButtonLoading = false;
                                    });
                                } else {
                                    done();
                                }
                            }
                        }).then(() => {

                        });
                    });
                    return;
                } else {
                    // 如果结算申请单号在【发票登记BMS.EF_INVOICE_HEADER】不存在发票信息，但是按照结算申请单号匹配【发票管理】的“结算申请单号”查询存在发票信息
                    const res = await extsysInvoiceQuery({
                        pageNo: 1,
                        pageSize: 10,
                        apApplyNo: this.currObject.apApplyNo
                    });
                    if (res && res.code === '0' && res.data && res.data.list && res.data.list.length) {
                        return this.$message.warning('该结算申请单已生成过发票，请先在【发票管理】查询处理完毕再作废单据。');
                    }
                }
            }

            this.$confirm(`系统会自动移除发票，重新生成结算申请单可以再次关联这些发票，请确定是否继续作废结算申请单？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        this.loading = true;
                        const params = { apApplyNo: this.currObject.apApplyNo, jobId: this.currObject.jobId, recVer: this.currObject.recVer };
                        cancelApply(params).then(res => {
                            if ((res && res.code === '0' && res.data ? res.data.code === '0' : true)) {
                                this.$message.success('作废成功');
                                this.apApplyListApDetail();
                                this.refreshInvoice();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                            this.loading = false;
                        }).finally(() => {
                            done();
                            instance.confirmButtonText = '确定';
                            instance.confirmButtonLoading = false;
                            instance.cancelButtonLoading = false;
                        });
                    } else {
                        done();
                    }
                }
            }).then(() => {

            });
        },
        sendFiles() {
            this.uploadDataArr.forEach(item => {
                this.simpleUpload(item); // 简单数据上传
            });
        },
        submitUpload(uploadData) {
            this.uploadDataArr.push(uploadData);
            clearTimeout(this.isReady);
            this.isReady = setTimeout(() => {
                this.sendFiles();
            }, 100);
        },
        async simpleUpload(uploadData) { // 发票上传
            this.loading = true;
            const file = new File([uploadData.file], uploadData.file.name, {
                type: uploadData.file.type
            });
            const formData = new FormData();
            formData.append('file', file);
            formData.append('businessId', this.currObject.jobId);
            formData.append('systemSource', '10');
            formData.append('moduleCode', 'EfApApplyEditor');
            formData.append('billNo_AA', this.currObject.apApplyNo);
            upload(formData).then(res => {
                this.uploadNumbers++;
                if (res && res.code === '0') {
                    this.invoiceUplodList = [...this.invoiceUplodList, ...res.data];
                    if (!this.requestParam) {
                        this.requestParam = {};
                        this.requestParam.businessId = this.currObject.jobId;
                        this.requestParam.systemSource = '10';
                        this.requestParam.moduleCode = 'EfApApplyEditor';
                        this.requestParam.skipCheck = 'Y';
                        this.requestParam.billNo_AA = this.currObject.apApplyNo;
                    }
                    this.refreshInvoice();
                }
                // 所有图片上传完 打开弹窗
                if (this.uploadNumbers === this.uploadDataArr.length) {
                    this.uploadInvoice(); // 打开弹窗
                    this.loading = false;
                }
            });
        },

        sendSalesFiles() {
            this.uploadDataArr.forEach(item => {
                this.simpleSalesUpload(item); // 简单数据上传
            });
        },
        submitSalesUpload(uploadData) {
            this.uploadDataArr = [];
            this.uploadDataArr.push(uploadData);
            clearTimeout(this.isReady);
            this.isReady = setTimeout(() => {
                this.sendSalesFiles();
            }, 100);
        },
        async simpleSalesUpload(uploadData) { //
            this.loading = true;
            const file = new File([uploadData.file], uploadData.file.name, {
                type: uploadData.file.type
            });
            const formData = new FormData();
            formData.append('file', file);
            formData.append('businessId', this.currObject.jobId);
            formData.append('systemSource', '10');
            formData.append('moduleCode', 'EfApApplyEditor');
            formData.append('applyNo_AA', this.currObject.apApplyNo);
            formData.append('type', 'apapply');
            salesUpload(formData).then(res => {
                if (res && res.code === '0') {
                    if (res.data[0].code === '0') {
                        this.updateAnnexesList();
                        this.$message.success('操作成功');
                    } else {
                        this.$message.error(res.data[0].message);
                    }
                } else {
                    this.$message.error(res.errMsg);
                }
            }).finally(() => { this.loading = false; });
        },
        clearCacheDataMall() {
            this.invoiceUplodList = [];
            this.uploadDataArr = [];
            this.uploadNumbers = 0;
        }
    }
};
